import React,{useState} from "react";
import {updateScoreAnalysisAnswer} from "../utils/scoreAnalysis.js";

function KeyBlank({value,onChange,label,locked,style}) {
  const [focused,setFocused]=useState(false);
  function accidental(acc) {
    const match=String(value || '').match(/^(\s*[A-Ga-g])([#b♭♯]*)(.*)$/);
    onChange(match?match[1]+acc+match[3]:acc);
  }
  return <span style={{position:'relative',display:'inline-block'}}>
    <input aria-label={label} value={value || ''} readOnly={locked} onChange={e=>onChange(e.target.value)}
      onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)} autoComplete="off" spellCheck={false} style={style}/>
    {focused&&!locked&&<span className="score-analysis-accidentals">
      {[["♭","♭"],["♯","♯"],["♮",""]].map(([glyph,acc])=><button type="button" key={glyph} aria-label={`Insert ${glyph} in ${label}`}
        onMouseDown={e=>e.preventDefault()} onClick={()=>accidental(acc)}>{glyph}</button>)}
    </span>}
  </span>;
}
export default function ScoreAnalysisFields({config,value={},onChange,mode="edit",feedback}) {
  const saved=value&&typeof value==='object'?value:{},locked=mode!=='edit';
  const change=(group,id,text,field)=>{if(!locked)onChange?.(updateScoreAnalysisAnswer(saved,group,id,text,field));};
  const style=(id,width)=>{
    const correct=feedback?.parts?.[id]?.correct;
    return {width,maxWidth:'100%',fontSize:16,padding:'6px 5px',border:0,borderBottom:`2px solid ${mode==='review'&&typeof correct==='boolean'?(correct?'#2e7d32':'#b91c1c'):'#687387'}`,borderRadius:0,background:'white',color:'#111',opacity:1};
  };
  return <div className="score-analysis-fields">
    <p>The Sonata-Allegro Form consists of three principal parts:</p>
    <div className="score-analysis-parts">
      {(config.principalParts || []).map(row=><label key={row.id}>
        <span>{row.label}</span><input aria-label={`Principal part ${row.id}`} value={saved.parts?.[row.id] || ''} readOnly={locked}
          autoComplete="off" onChange={e=>change('parts',row.id,e.target.value)} style={style(`parts.${row.id}`,190)}/>
      </label>)}
    </div>
    <p>Parts I and III are divided into two parts:</p>
    <div className="score-analysis-parts">
      {(config.themeNames || []).map(row=><label key={row.id}>
        <span>{row.label}</span><input aria-label={`Theme ${row.id} name`} value={saved.themes?.[row.id] || ''} readOnly={locked}
          autoComplete="off" onChange={e=>change('themes',row.id,e.target.value)} style={style(`themes.${row.id}`,170)}/><span>Theme</span>
      </label>)}
    </div>
    <p>Using the divisions listed above, analyze {config.scoreTitle || 'the score'}.</p>
    <div className="score-analysis-section-box">
      {(config.sectionRows || []).map(row=><div className="score-analysis-section-row" key={row.id}>
        <label><span>{row.label} begins at measure</span>
          <input aria-label={`${row.label} starting measure`} inputMode="numeric" value={saved.sections?.[row.id]?.measure || ''} readOnly={locked}
            autoComplete="off" onChange={e=>change('sections',row.id,e.target.value,'measure')} style={style(`sections.${row.id}.measure`,58)}/>
        </label>
        {row.hasKey&&<label><span>and is in the key of</span>
          <KeyBlank label={`${row.label} key`} value={saved.sections?.[row.id]?.key || ''} locked={locked}
            onChange={text=>change('sections',row.id,text,'key')} style={style(`sections.${row.id}.key`,160)}/>
        </label>}
      </div>)}
    </div>
  </div>;
}
